


<template>
  <div>

        <el-form class="select" style="display: flex; flex-wrap: wrap;">

            <el-form-item label="学生姓名:" label-width="100px" style="width: 30%;" v-if="toAdd != '学科组'">
              <el-select  placeholder="请选择"   v-model="teacherName"  style="width: 100%" clearable  filterable  >
                <el-option v-for="item in teacherArr"  :key="item.id"  :value="item.id"  :label="item.realname" >  </el-option>
              </el-select>
            </el-form-item>

             <el-form-item label="学科组:" label-width="100px" style="width: 30%;" v-else>
              <el-select  placeholder="请选择学科组"  v-model="SubjectGroup"  style="width: 100%" clearable  filterable  >
                 <el-option v-for="item in SubjectGroupList" :key="item.teacherId" :label="item.teacherName"  :value="item.teacherId"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="学生状态:" label-width="100px" style="width: 30%;">
              <el-select v-model="studentStatus"  filterable placeholder="请选择学生状态"  style="width: 100%" clearable >
                <el-option style="margin-left: 10px" v-for="teacher in studentStatusList"  :key="teacher.id"   :label="teacher.name"  :value="teacher.id"  > </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="学生类型:" label-width="100px" style="width: 30%;">
              <el-select v-model="newClassType"  filterable placeholder="请选择学生类型"  style="width: 100%" clearable >
                <el-option style="margin-left: 10px" v-for="teacher in newClassTypeList"  :key="teacher.id"   :label="teacher.name"  :value="teacher.id"  > </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="所在地域:" label-width="100px" style="width: 30%;">
              <el-select  placeholder="请选择所在地域"  v-model="regionName"  style="width: 100%"   clearable  filterable  >
                <el-option  v-for="item in optionsListt" :key="item.id"  :value="item.dictType"  :label="item.dictValue"  >  </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="首次课日期:" label-width="100px" style="width: 50%;text-align: justify;">
              <el-date-picker v-model="dateTimeList"   type="daterange"  style="width: 100%;"   value-format="yyyy-MM-dd"   range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期">   </el-date-picker>
            </el-form-item>
        </el-form>


        <div style=" text-align: end; padding: 10px;">
          <el-button @click="handleClear" icon="el-icon-close" size="small" class="btns">清除</el-button>
          <el-button type="primary" @click="handleSearch" size="small" class="btns" icon="el-icon-search">搜索</el-button>
          <el-button type="primary" icon="el-icon-download" size="small" class="btns" @click="handleDownload">导出</el-button>
        </div>



    <!-- <div style="margin-top: 15px;">

      <div style="display: flex;justify-content: space-between;margin-bottom: 10px;margin-top: 10px;" v-for="(item,index) in dateList" :key="index" class="chart-item">

        <el-card style="width: 35%; border-radius: 15px;">
          <div ref="charts" :id="`chart-chart`" style="width: 100%; height: 150px;"></div>
        </el-card>

        <el-card style="width: 20%; border-radius: 15px;">
            <div style="text-align: center;">线下</div>
            <div style="display: flex; margin-top: 10px;">
              <div :id="`offline-pie-${index}`" style="width: 100%; height: 120px; margin-top: 10px;"></div>
            </div>
        </el-card>

        <el-card style="width: 20%; border-radius: 15px;">
            <div style="text-align: center;">规划</div>
            <div style="display: flex; margin-top: 10px;">
              <div :id="`plan-pie-${index}`" style="width: 100%; height: 120px; margin-top: 10px;"></div>
            </div>
        </el-card>

        <el-card style="width: 20%; border-radius: 15px;">
            <div style="text-align: center;">纯补课</div>
            <div style="display: flex; margin-top: 10px;">
              <div :id="`makeup-pie-${index}`" style="width: 100%; height: 120px; margin-top: 10px;"></div>
            </div>
        </el-card>

      </div>

    </div> -->


    <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}"  :data="dataTableList" border height="700">
        <el-table-column prop="studentName" header-align="center"  label="学生姓名"  v-if="toAdd != '学科组'"></el-table-column>
        <el-table-column prop="" header-align="center"  label="学科组" v-else></el-table-column>
        <el-table-column prop="regionName" header-align="center"  label="所属地域" ></el-table-column>
        <el-table-column prop="classType" header-align="center"  label="学生类型" ></el-table-column>
        <el-table-column prop="entiretySucTage" header-align="center"  label="整体成功率" ></el-table-column>
        <el-table-column header-align="center" label="查看详情" width="150px">
          <template slot-scope="scope">
            <el-button type="text" @click="details(scope.row)">详情</el-button>
          </template>
        </el-table-column>
    </el-table>


     <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"  :current-page="pageNum" :page-size="pageSize"  
        layout="prev, pager, next,sizes, jumper" :total="total">
     </el-pagination>

    


    <el-dialog width="80%" :visible.sync="showPopUpNotification" :before-close="showPopUpNotificationCler" :close-on-click-modal="false" modal-append-to-body :append-to-body="true">
        <fistClassComponents v-if="showPopUpNotification" :paramsComponents="params_ZUJIAN"></fistClassComponents>
    </el-dialog>

   
  </div>
</template>



<script>

import axios from "axios";
import apiBaseUrl from "../../../config/api";
import { getTeachers_s,  } from "@/api/firstClassApi";
import * as echarts from 'echarts';
import loadingUtils from "../../utils/loading";
import fistClassComponents from '../fistClass.vue';
import { getStudentsType } from "@/api/fiveClassApi"


export default {
  name: 'FistClassTableStudentEnd',
  components: {
    fistClassComponents,
  },
  props: {
    type: {
      type: String,
      default: '未知'
    },
    toAdd: {
      type: String,
      default: ''
    }
  },
  data() {
    return {

      teacherName: '',
      teacherArr: [],

      newClassType: '',
      newClassTypeList: [
        {id:1,name:'规划'},
        {id:2,name:'线下'},
        {id:3,name:'纯补课'},
      ],

      regionName: '',
      optionsListt: [],

      dateTimeList: [],


      showPopUpNotification: false,
      params_ZUJIAN: null,



      dateList: [{}], // 用于存储日期列表
      calculationType: 1, // 1: 差异率, 2: 差值, 3: 无差异率


      dataTableList: [], // 用于存储表格数据

      chartData:[{}], // 用于存储图表数据
      
      pageSize: 10,
      pageNum: 1,
      total: 0,


      studentStatus: 8,
      studentStatusList: [
        {id:1,name:'在读'},
        {id:2,name:'结业'},
        {id:3,name:'停课'},
        {id:4,name:'流失'},
        {id:8,name:'全部'},
      ],

      SubjectGroupList: [],
      SubjectGroup: '',
       
    }
  },

  computed: {
   
  },

  mounted() {
     this.SubjectGroupList = JSON.parse(sessionStorage.getItem('SubjectGroupList'))

     getStudentsType(2).then(res => {
         let data = res.data
         getStudentsType(1).then(_res => {
              this.teacherArr = [...data,..._res.data]
         })
     })

     

    //  getTeachers_s().then((res) => {  this.teacherArr = res.data   })
     axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,{ headers: { 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
        this.optionsListt = res.data.data
     })

    this.dateTimeList = this.getDefaultDateRange()

    this.handleGetDateList()

  },

  methods: {

    formatDate(date) {
          const y = date.getFullYear();
          let m = date.getMonth() + 1; // Months are zero based
          let d = date.getDate();
          m = m < 10 ? '0' + m : m;
          d = d < 10 ? '0' + d : d;
          return `${y}-${m}-${d}`;
    },


    getDefaultDateRange() {
        const today = new Date();
        const year = today.getFullYear();
        let startMonth = today.getMonth() - 6; // 半年前的月份
        let startYear = year;
        
        // 调整年份和月份，确保开始月份正确
        if (startMonth < 0) {
            startMonth += 12;
            startYear -= 1;
        }
        
        // 开始日期总是当月的第一天
        const startDate = new Date(startYear, startMonth, 1);
        
        // 结束日期是当前月份的最后一天
        const endYear = today.getFullYear();
        const endMonth = today.getMonth();
        const endDate = new Date(endYear, endMonth + 1, 0); // 0表示前一个月的最后一天

        return [this.formatDate(startDate), this.formatDate(endDate)];
    },

    handleSizeChange(e){
       this.pageSize = e
       this.handleGetDateList()
    },

    handleCurrentChange(e){
       this.pageNum = e
       this.handleGetDateList()
    },

    showPopUpNotificationCler() {
      this.params_ZUJIAN = null;
      this.showPopUpNotification = false;
    },


    details(row) {
      this.params_ZUJIAN = {
        studentId:row.studentId,
        startTime: this.dateTimeList .length > 1 ? this.dateTimeList[0] : '',
        endTime: this.dateTimeList .length > 1 ? this.dateTimeList[1] : '',
        regionName: this.regionName,
        classType: this.newClassType,
        studentStatus: this.studentStatus,
      };
      this.showPopUpNotification = true;
    },

    handleSearch() {
       this.pageNum = 1
       this.pageSize = 10
       this.handleGetDateList();
    },

    handleClear() {
      this.teacherName = '';
      this.studentStatus = 8
      this.newClassType = '';
      this.regionName = '';
      this.dateTimeList = this.getDefaultDateRange() ;
      this.pageNum = 1;
      this.pageSize = 10;
      this.total = 0;
      this.handleGetDateList();
    },

    handleDownload(){

      loadingUtils.startLoading();

      let data = { 
        studentId: this.teacherName,
        regionName: this.regionName,
        startTime: this.dateTimeList .length > 1 ? this.dateTimeList[0] : '',
        endTime: this.dateTimeList .length > 1 ? this.dateTimeList[1] : '',
        classType: this.newClassType,
        pageSize: this.pageSize,
        pageIndex: this.pageNum,
        queryType: 2,
        studentStatus: this.studentStatus,
        exportType: 2
      }

      let url = this.type === '首次课图表' ? '/firstRecordDiagram/exportStudentFirstDiagram' :
                  this.type === '新增率图表' ? '/classSales/exportStatistics' :
                    this.type === '到课率图表' ? '/scheduleComplete/exportStudentSchedule' :
                      this.type === '取消率图表' ? '/lossCourseDiagram/queryStudentCourseDiagram' :
                        this.type === '流失率图表' ? '/classSales/exportStatistics' :
                          this.type === '续报率图表' ? '/continuedReport/queryStudentContinuedReportDiagram' : '/classSales/exportStatistics'

      let xlsxName = this.type === '首次课图表' ? '首次课学生统计数据成功率' :
                        this.type === '新增率图表' ? '新增率图表' :
                          this.type === '到课率图表' ? '到课率图表' :
                            this.type === '取消率图表' ? '取消率图表' :
                              this.type === '流失率图表' ? '流失率图表' :
                                this.type === '续报率图表' ? '续报率图表' : ''

      axios.post(`${apiBaseUrl}${url}`, data, { responseType: "blob", headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then((response) => {
        const blob = new Blob([response.data], { type: "application/vnd.ms-excel"})
      
        setTimeout(() => {
          loadingUtils.endLoading()
        }, 500)

        const downloadLink = document.createElement("a")
        downloadLink.href = URL.createObjectURL(blob)
        downloadLink.download = xlsxName + ".xlsx"
        downloadLink.click()
      }).catch((error) => {
        this.$message.error(error)
        setTimeout(() => {
          loadingUtils.endLoading()
        }, 500)
      })

    },


    handleGetDateList(){

      let data = {
        studentId: this.teacherName,
        regionName: this.regionName,
        startTime: this.dateTimeList .length > 1 ? this.dateTimeList[0] : '',
        endTime: this.dateTimeList .length > 1 ? this.dateTimeList[1] : '',
        classType: this.newClassType,
        pageSize: this.pageSize,
        pageIndex: this.pageNum,
        queryType: 2,
        studentStatus: this.studentStatus,
      }
     
      axios.post(`${apiBaseUrl}/firstRecordDiagram/queryStudentFirstDiagramNum`, data ,{ headers: {'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
         if(res.data.code === 200){
            if(res.data.code === 200){

              // res.data.data = [
              //   {
              //     categoryDiff: "0",
              //     categoryNumber: "1.97",
              //     categoryPercentage: "0.00%",
              //     categoryType: "3",
              //     channelMakeNumber: "27",
              //     channelMakeProportion: "2.71%",
              //     channelOfflineNumber: "200",
              //     channelOfflineProportion: "20.10%",
              //     channelProjectNumber: "768",
              //     channelProjectProportion: "77.19%",
              //     classDiff: "0",
              //     classNumber: "7.90",
              //     classPercentage: "0.00%",
              //     classType: "3",
              //     endDate: "2024-12-31",
              //     endingDiff: "0",
              //     endingNumber: "995",
              //     endingPercentage: "0.00%",
              //     endingType: "3",
              //     startDate: "2024-12-01",
              //     studentDiff: "0",
              //     studentNumber: "126",
              //     studentPercentage: "0.00%",
              //     studentType: "3",
              //   }
              // ]


              let datas = res.data.data
              this.dateList = datas.entity
              this.dataTableList = datas.entity

              this.total = datas.allTotal
              this.pageSize = datas.pageSize
              this.pageNum = datas.pageIndex


              let arr = []

              datas.entity.map((item) => {
                  console.log(item)
                  arr.push({
                    channelOfflineNumber: Number(item.channelOfflineNumber),
                    channelMakeNumber: Number(item.channelMakeNumber),
                    channelProjectNumber: Number(item.channelProjectNumber),
                  })
              })
              this.chartData = arr.length > 0 ? arr : []

              // this.$message({ type: 'success', message: '查询成功~'  })
            
            }else{
              this.dateList = []
              this.chartData = []
              this.$message({ type: 'error', message: res.data.message ? res.data.message : '出错了，请联系管理员~'  })
            }
         }else{
            this.dateList = []
            this.chartData = []
            this.$message({ type: 'error', message: res.data.message ? res.data.message : '出错了，请联系管理员~'  })
             setTimeout(() => {
              loadingUtils.endLoading()
            }, 500)
         }
      }).catch(err => {
         this.dateList = []
         this.chartData = []
         this.$message({ type: 'error', message: err.message ? err.message : '出错了，请联系管理员~'  })
          setTimeout(() => {
            loadingUtils.endLoading()
          }, 500)
      })

    },


    getChartOption(itmeIndex) {

      // let isTyleText = '月'
      // let isTyleText =  this.calculationMethod === 1 ? '日' : '月'
     
      return {
        title: {
          // text: isTyleText === '月' ? this.getYearRange(this.dateList[itmeIndex].startDate) + '年' + '' + this.getMonthRange(this.dateList[itmeIndex].startDate)  + '首次课成功率' : isTyleText === '日' ? '首次课成功率' : '',
          // subtext:  isTyleText === '月' ? '' : this.dateList[itmeIndex].startDate +' ~ ' + this.dateList[itmeIndex].endDate,
          left: 'center',
          minAngle: 5,
          textStyle: { 
            fontSize: 14, 
            color: '#333',
            verticalAlign: 'top'  
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)',
        },
        legend: {
           orient: 'horizontal',
           left: 'left',
           top: 35,
           data: ['否', '是', '未知'],
           icon: 'circle', // 让图例变成圆点
           selectedMode: false 
        },
        series: [
          {
            minAngle: 5,
            name: '课消渠道',
            type: 'pie',
            radius: '60%',
            center: ['50%', '70%'], // 这里第二个参数越大越往下
            data: [
                { value: this.chartData[itmeIndex] && this.chartData[itmeIndex].channelOfflineNumber ? this.chartData[itmeIndex].channelOfflineNumber : 0.00001, name: '否' },
                { value: this.chartData[itmeIndex] && this.chartData[itmeIndex].channelMakeNumber ? this.chartData[itmeIndex].channelMakeNumber : 0.00001, name: '是' },
                { value: this.chartData[itmeIndex] && this.chartData[itmeIndex].channelProjectNumber ? this.chartData[itmeIndex].channelProjectNumber : 0.00001, name: '未知' }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              formatter: '{b}: ({d}%)', // 用英文括号
            },
            itemStyle: {
              color: function(params) {
                let colorList = ['#4472c4', '#3dc6c1', '#f6c846'] 
                return colorList[params.dataIndex];
              }
            },
          }
        ]
      }
    },


    getMonthRange(dateString) {
      if (dateString) {
        const parts = dateString.split('-');
        if (parts.length >= 2) {
            return parseInt(parts[1], 10); 
        } else {
            throw new Error('Invalid date format');
        }
      } else {
        return '';
      }
     
    },

    // 获取年份
    getYearRange(dateString) {
      if (dateString) {
        const year = dateString.substring(0, 4);
        return year;
      }else {
        return '';
      }
    },


   

  },


}


</script>




<style  scoped>

.btns{
   background-color: #428BCA;
   border-color: #428BCA;
   color: #fff;
}



</style>




// WEBPACK FOOTER //
// src/CourseTypeAnalysisEchart/FistClassTable/FistClassTableStudentEnd.vue